import React, { useState, useEffect } from "react";
import { TextArea, NumericTextBox, Input } from "@progress/kendo-react-inputs";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { filterBy } from "@progress/kendo-data-query";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Label } from "@progress/kendo-react-labels";
import { Button } from "@progress/kendo-react-buttons";
import SubmitButton from "components/common/SubmitButton";
import { useSelector, useDispatch } from "react-redux";
import MattersCombobox from "../Postings/MattersComboBox";
import { DocumentsUpload } from "../Postings/DcoumentsUpload";
import { addFiles, clearFile } from "actions/files.action";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import MatterAccount from "../MatterLedger/MatterAccount";
import {
  clearMattersBalances,
  getMattersBalances,
} from "actions/matters.action";
import {
  createChitRequest,
} from "actions/chitRequest.action";
import { getChitRequest, updateChitRequest, createChitRequest as createChitRequestAPI } from "api";
import { toast } from "react-toastify";
import { useUploadForm } from "components/fileUploadHook";
import { onFileUpload } from "services/fileDataService";
import { usePreComponentCalls } from "components/layout/PreComponentLoad";
import { useActiveFeeEarner } from "services/userService";
import CalenderCustomToggleButton from "components/common/CalenderCustomToogleButton";
import MatterDetails from "pages/MatterLedger/MatterDetails";
import { ComboBoxComponent } from "./ChitRequestComponents";
import styles from "./ChitRequest.module.scss";
import { useActiveVats } from "services/vatService";
import { useActiveBranches } from "services/branchService";
import CONSTANT from "CONSTANT/Matter/PostingTypes";
import { getPostingTypes } from "services/postingTypesService";
import { useActiveSuppliers } from "services/supplierService";

const ChitRequest = (props) => {
  const IS_MODAL = props.component === "modal";
  const [list, setList] = useState([]);
  const [validator, setValidator] = useState({});
  const { handleCalls } = usePreComponentCalls();
  const { data: activevatsdata = [] } = useActiveVats();
  const [loading, setLoading] = useState(false);
  const [resetDocs, setresetDocs] = useState(false);
  const { data: branchesList } = useActiveBranches();
  const { data: feeearnerdata } = useActiveFeeEarner();
  const [postingTypes, setPostingTypes] = useState([]);
  const date = new Date();
  const [type, settype] = useState("");
  const [vatvalue, setvatvalue] = useState();
  const [matterref, setmatterref] = useState(
    IS_MODAL ? props.matter?.matterId : null
  );
  const [feeearnerref, setfeeearnerref] = useState();
  const [matterBalanceClear, setMatterBalanceClear] = useState(false);
  const [matter, setMatter] = useState(IS_MODAL ? props.matter : null);
  const [branch, setbranch] = useState({ branchId: "" });
  const [nominal, setnominal] = useState({ nominalRef: "" });
  const [suppliervalue, setsuppliervalue] = useState({ supplierRef: "" });
  const [errorModal, setErrorModal] = useState(false);
  const [officevalue, setofficevalue] = useState("");
  const [clientvalue, setclientvalue] = useState("");
  const [ddavalue, setddavalue] = useState("");
  const [state, setstate] = useState("");
  const [payee, setpayee] = useState("");
  const [payer, setpayer] = useState("");
  const [vatamount, setvatamount] = useState();
  const [netamount, setnetamount] = useState(0);
  const [grossamount, setgrossamount] = useState("");
  const [resetmatter, setresetmatter] = useState(false);
  const [details, setdetails] = useState("");
  const [dateselector, setdateselector] = useState(date);
  const { data: suppliersdata } = useActiveSuppliers();
  const [counselfee, setcounselfee] = useState(false);
  const [validation_message, setvalidation_message] = useState(false);
  const [documentUpload, setDocumentsUpload] = useState(false);
  const [vatsdata, setvatsData] = useState();
  const [feeearner, setfeeearnerData] = useState();
  const [branchesdata, setbranchesdata] = useState();
  const [suppliers, setsuppliersdata] = useState([]);
  const [nominaldata, setnominaldata] = useState([]);
  const [officedata, setofficedata] = useState([]);
  const [clientdata, setclientdata] = useState([]);
  const [ddadata, setddadata] = useState([]);
  // Initialize loading state based on whether we need to fetch chit data
  const [isLoadingChitData, setIsLoadingChitData] = useState(
    IS_MODAL && props.activityData?.chitRequestId ? true : false
  );

  const mattersBalances = useSelector((state) => state.mattersList);

  useEffect(() => {
    handleCalls("Chit Request");
  }, []);

  const fetchData = async () => {
    try {
      const postingData = await getPostingTypes("chits");
      if (!Array.isArray(postingData) || postingData.length === 0) return;

      setPostingTypes(postingData);

      const displayFields = postingData[0]?.displayFields || [];
      const listToShow = displayFields.map((item) => item.name);

      const validatorObj = {};
      displayFields.forEach((item) => {
        validatorObj[item.name] = item.displayName;
      });

      setList(listToShow);
      setValidator(validatorObj);
    } catch (error) {
      console.error("Failed to fetch posting types:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [props.name]);

  useEffect(() => {
    setLoading(true);
    if (
      list?.length > 0 &&
      IS_MODAL &&
      mattersBalances?.mattersChitRequest?.data?.matterRef !== undefined
    ) {
      setLoading(false);
    } else if (list?.length > 0 && !IS_MODAL) {
      setLoading(false);
    }
  }, [list]);

  const dispatch = useDispatch();

  const onChangesupplier = (event) => {
    if (event !== undefined && event !== null) {
      setsuppliervalue(event.value);
    }
  };
  const onChangeofficebank = (event) => {
    if (event !== undefined && event !== null) {
      setofficevalue(event.value);
    }
  };
  const onChangeclientbank = (event) => {
    if (event !== undefined && event !== null) {
      setclientvalue(event.value);
    }
  };
  const onChangeddabank = (event) => {
    if (event !== undefined && event !== null) {
      setddavalue(event.value);
    }
  };
  useEffect(() => {
    if (IS_MODAL) {
      dispatch(getMattersBalances(props?.matter?.matterId, "Chit Request"));
    }
  }, []);

  // Handle prefilling data from activity (for edit mode)
  useEffect(() => {
    const fetchAndPrefillChitData = async () => {
      if (!props.activityData || !IS_MODAL) return;
      
      // Wait for posting types to be loaded before fetching chit data
      if (postingTypes.length === 0) return;

      // If chitRequestId exists, fetch and prefill chit data
      if (props.activityData.chitRequestId) {
        // Loading state already initialized to true
        try {
          const response = await getChitRequest(props.activityData.chitRequestId);
          const chit = response.data?.data;

          if (chit) {
            // Prefill form fields
            chit.details && setdetails(chit.details);
            chit.date && setdateselector(new Date(chit.date));
            chit.reference && setstate(chit.reference);
            chit.netAmount && setnetamount(chit.netAmount);
            chit.vatAmount && setvatamount(chit.vatAmount);
            chit.payee && setpayee(chit.payee);
            chit.payer && setpayer(chit.payer);
            chit.isCounselFee !== undefined && setcounselfee(chit.isCounselFee);

            // Store feeEarnerRef for later processing
            chit.feeEarnerRef && setfeeearnerref(chit.feeEarnerRef);

            // Set complex objects
            chit.supplierRef && setsuppliervalue({ supplierRef: chit.supplierRef });
            chit.nominalRef && setnominal({ nominalRef: chit.nominalRef });
            chit.branchId && setbranch({ branchId: chit.branchId });
            chit.officeBank && setofficevalue({ nominalRef: chit.officeBank });
            chit.clientBank && setclientvalue({ nominalRef: chit.clientBank });
            chit.ddaBank && setddavalue({ nominalRef: chit.ddaBank });

            // Store VAT data for later processing
            console.log(chit , activevatsdata)
            if (chit.vatCode) {
              const vatValue = activevatsdata.find((item) => item.vatCodeId === chit.vatCode)
              setvatvalue(vatValue);
            }

            // Set posting type directly since we have posting types loaded
            if (chit.postingType !== undefined && chit.postingType !== null) {
              const matchingPostingType = postingTypes.find((postingType) => postingType.code === chit.postingType);
              if (matchingPostingType) {
                settype(matchingPostingType);
                console.log(`Found posting type: ${matchingPostingType.name || matchingPostingType.description} (code: ${chit.postingType})`);
              } else {
                console.warn(`Posting type with code ${chit.postingType} not found in posting types:`, postingTypes.map(pt => ({ code: pt.code, name: pt.name || pt.description })));
              }
            }
          }
        } catch (error) {
          console.error("Error fetching chit data:", error);
        } finally {
          setIsLoadingChitData(false);
        }
      } else {
        // Fallback: prefill with basic activity data if no chitRequestId
        const { details, date, feeEarnerRef } = props.activityData;
        details && setdetails(details);
        date && setdateselector(new Date(date));
        
        // Store feeEarnerRef for later processing
        feeEarnerRef && setfeeearnerref(feeEarnerRef);
      }
    };

    fetchAndPrefillChitData();
  }, [props.activityData, IS_MODAL, postingTypes]);

  // Separate useEffect to handle feeEarner when data becomes available
  useEffect(() => {
    if (feeearnerdata?.length > 0 && feeearnerref && typeof feeearnerref === 'string') {
      // Convert feeEarnerRef string to feeEarner object
      const matchingFeeEarner = feeearnerdata.find(
        (fe) => fe.userRef === feeearnerref
      );
      if (matchingFeeEarner) {
        setfeeearnerref(matchingFeeEarner);
      }
    }
  }, [feeearnerdata, feeearnerref]);

  // Separate useEffect to handle VAT code when data becomes available
  useEffect(() => {
    if (activevatsdata?.length > 0 && vatvalue && typeof vatvalue.vatCodeId === 'number') {
      // Find matching VAT object from the VAT data array
      const matchingVat = activevatsdata.find((vat) => vat.vatCodeId === vatvalue.vatCodeId);
      if (matchingVat && !vatvalue.display) {
        // Update with full VAT object if we only have the ID and rate
        setvatvalue({
          ...vatvalue,
          ...matchingVat
        });
        console.log(`Found VAT code: ${matchingVat.display} (ID: ${vatvalue.vatCodeId})`);
      }
    }
  }, [activevatsdata, vatvalue]);

  const officeapidata = useSelector((state) => {
    return state.nominalList.officeList.data.map((item) => {
      item.representation = item.nominalRef + " - " + item?.nominalName;
      return item;
    });
  });
  const clientapidata = useSelector((state) => {
    return state.nominalList.clientList.data.map((item) => {
      item.representation = item.nominalRef + " - " + item?.nominalName;
      return item;
    });
  });
  const ddaapidata = useSelector((state) => {
    return state.nominalList.ddaList.data.map((item) => {
      item.representation = item.nominalRef + " - " + item?.nominalName;
      return item;
    });
  });
  const result = useSelector((state) => {
    return state.postingsdocs;
  });

  const nominallist = useSelector((state) => {
    let array = [];
    let list = state.nominalList.activenominals.data.map((item) => {
      if (item.subType === "ProfitAndLoss_Expense") {
        const templist = item;
        templist.representation = item.nominalRef + "  -  " + item.nominalName;
        array.push(item);
        return templist;
      }
    });
    return array;
  });

  const handleChange = (event) => {
    if (props.name === "All Postings" && filesCurrentData[0] !== undefined) {
      setErrorModal(true);
      return;
    } else if (
      props.name === "Office Postings" &&
      filesCurrentOfficeData[0] !== undefined
    ) {
      setErrorModal(true);
      return;
    } else if (
      props.name === "Client Postings" &&
      filesCurrentClientData[0] !== undefined
    ) {
      setErrorModal(true);
      return;
    }
    // setmatterref(null);
    setresetmatter(!resetmatter);
    setvalidation_message(false);
    settype(event.value);
    const list = [];
    const validator = {};
    event.value.displayFields.map((item) => {
      list.push(item.name);
      validator[item.name] = item.displayName;
    });
    setList(list);
    setValidator(validator);
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (
        !suppliersdata?.length ||
        !nominaldata?.length ||
        !officedata?.length ||
        !clientdata?.length ||
        !ddadata?.length ||
        !feeearnerdata?.length ||
        !vatsdata?.length
      ) {
        setvatsData(activevatsdata.slice());
        setfeeearnerData(feeearnerdata.slice());
        setsuppliersdata(suppliersdata.slice());
        setnominaldata(nominallist.slice());
        setofficedata(officeapidata.slice());
        setclientdata(clientapidata.slice());
        setddadata(ddaapidata.slice());
      }
    }, 2000);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [
    feeearnerdata,
    activevatsdata,
    suppliersdata,
    officeapidata,
    clientapidata,
    ddaapidata,
  ]);

  const onChangematter = (e) => {
    if (IS_MODAL) return;
    setMatterBalanceClear(false);
    let event = e.value;
    if (event !== null && event !== undefined) {
      setMatter(event);
      dispatch(getMattersBalances(event.matterId, "Chit Request"));
      setmatterref(event.matterId);
    } else {
      setmatterref(null);
      setMatter(null);
      setMatterBalanceClear(true);
      dispatch(clearMattersBalances("Chit Request"));
    }
  };

  const filterData = (filter) => {
    const datas = activevatsdata.slice();
    return filterBy(datas, filter);
  };

  const filterChange = (event) => {
    setvatsData(filterData(event.filter));
  };
  const filtersupplier = (filter) => {
    const data = suppliersdata.slice();
    return filterBy(data, filter);
  };
  const filterChangesupplier = (event) => {
    setsuppliersdata(filtersupplier(event.filter));
  };

  const filterofficebank = (filter) => {
    const data = officeapidata.slice();
    return filterBy(data, filter);
  };
  const filterChangeofficebank = (event) => {
    setofficedata(filterofficebank(event.filter));
  };
  const filterclientbank = (filter) => {
    const data = clientapidata.slice();
    return filterBy(data, filter);
  };
  const filterChangeclientbank = (event) => {
    setofficedata(filterclientbank(event.filter));
  };
  const filterddabank = (filter) => {
    const data = ddaapidata.slice();
    return filterBy(data, filter);
  };
  const filterChangeddabank = (event) => {
    setofficedata(filterddabank(event.filter));
  };
  const filterfeeearnerData = (filter) => {
    const data = feeearnerdata.slice();
    return filterBy(data, filter);
  };
  const filterfeeearner = (event) => {
    setfeeearnerData(filterfeeearnerData(event.filter));
  };
  const filternominalData = (filter) => {
    const data = nominallist.slice();
    return filterBy(data, filter);
  };
  const filternominal = (event) => {
    setnominaldata(filternominalData(event.filter));
  };
  const filterbranchesData = (filter) => {
    const data = branchesList.slice();
    return filterBy(data, filter);
  };
  const filterbranch = (event) => {
    setbranchesdata(filterbranchesData(event.filter));
  };

  const onChangevat = (event) => {
    setvatvalue(event.value);
  };
  const calculatevatamount = () => {
    if (vatvalue !== undefined && vatvalue !== null) {
      const vatamount = netamount * (vatvalue.rate / 100);
      setvatamount(vatamount);
    }
  };
  useEffect(() => {
    calculatevatamount();
  }, [vatvalue, netamount]);
  const onChangedateselect = (event) => {
    setdateselector(event.value);
  };

  const onChangefeeearner = (event) => {
    setfeeearnerref(event.value);
  };
  const onChangebranch = (event) => {
    setbranch(event.value);
  };
  const onChangenominal = (event) => {
    setnominal(event.value);
  };
  const onChangecounselfee = (event) => {
    setcounselfee(event.value);
  };
  const filesCurrentData = useSelector((state) => state.filesDownload.files);
  const filesCurrentOfficeData = useSelector(
    (state) => state.filesDownload.officePostingFiles
  );
  const filesCurrentClientData = useSelector(
    (state) => state.filesDownload.clientPostingFiles
  );
  const filesChitRequest = useSelector(
    (state) => state.filesDownload.chitRequestFiles
  );

  const handlesubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (
      (type.code !== "ODR" &&
        type.code !== "OCR" &&
        type.code !== "CDR" &&
        type.code !== "CCR" &&
        type.code !== "DDR" &&
        type.code !== "DCR" &&
        vatvalue === undefined) ||
      details === undefined ||
      netamount === 0
    ) {
      setvalidation_message(true);
      setLoading(false);
      return;
    }

    let baseData = {
      postingType: type.code,
      reference: state,
      matterID: matterref,
      netAmount: netamount,
      feeEarnerRef: feeearnerref.userRef,
      date: dateselector,
      transactionPeriod: 202201,
      currencyCode: "GBP",
      details: details,
      payee: payee,
      payer: payer,
      isCounselFee: counselfee,
      documentFiles: [],
    };

    if (filesChitRequest && filesChitRequest.length > 0) {
      const docsId = filesChitRequest.map((item) => item.fileID);
      baseData.documentFiles = docsId;
    }

    let data = [baseData];
    switch (type.code) {
      case "ODR":
      case "OCR":
      case "DPU":
        baseData.officeBank = officevalue?.nominalRef;
        break;
      case "CDR":
      case "CCR":
        baseData.clientBank = clientvalue?.nominalRef;
        break;
      case "DDR":
      case "DCR":
        baseData.ddaBank = ddavalue?.nominalRef;
        break;
      case "DUU":
        baseData.vatAmount = vatamount;
        baseData.vatCode = vatvalue.vatCodeId;
        baseData.vatRate = vatvalue.rate;
        break;
      case "PIN":
        baseData.vatAmount = vatamount;
        baseData.vatCode = vatvalue.vatCodeId;
        baseData.vatRate = vatvalue.rate;
        baseData.supplierRef = suppliervalue.supplierRef;
        baseData.branchId = branch.branchId;
        baseData.nominalRef = nominal.nominalRef;
        break;
      case "DIN":
        baseData.supplierRef = suppliervalue.supplierRef;
        baseData.vatAmount = vatamount;
        baseData.vatCode = vatvalue.vatCodeId;
        baseData.vatRate = vatvalue.rate;
        break;
      default:
        baseData.vatAmount = vatamount;
        baseData.vatCode = vatvalue.vatCodeId;
        baseData.vatRate = vatvalue.rate;
        break;
    }

    if (data[0].postingType !== "PIN") {
      data[0].branchId = undefined;
    }
    if (IS_MODAL) {
      data[0].matterID = props.matter?.matterId;
    }

    // Check if we're in edit mode (chitRequestId exists) or create mode
    if (props.activityData && props.activityData.chitRequestId) {
      // Edit mode - use direct API call with toast
      try {
        setLoading(true);
        await updateChitRequest(props.activityData.chitRequestId, data[0]);
        toast.success("Chit request updated successfully!");
        props.setModal && props.setModal(false);
        props.cancelEdit();
      } catch (error) {
        console.error("Error updating chit request:", error);
        toast.error("Failed to update chit request");
      } finally {
        setLoading(false);
      }
      return; // Exit early for edit mode
    } else {
      // Create mode - call API directly with toast
      try {
        await createChitRequestAPI(data);
        toast.success("Chit request created successfully!");
        props.setModal && props.setModal(false);
        resetfields();
      } catch (error) {
        console.error("Error creating chit request:", error);
        toast.error("Failed to create chit request");
      } finally {
        setLoading(false);
      }
    }
    // setresetmatter(!resetmatter);
  };
  const resetfields = () => {
    setvalidation_message(false);
    setgrossamount("");
    setstate("");
    setvatamount("");
    setmatterref(null);
    setpayee("");
    if (matterref) dispatch(getMattersBalances(matterref, props.name));
    setpayer("");
    setdetails("");
    setnetamount(0);
    setfeeearnerref(null);
    setdateselector(date);
    setvatvalue(null);
    setofficevalue(null);
    setclientvalue(null);
    setddavalue(null);
    setsuppliervalue({ supplierRef: "" });
    setnominal({ nominalRef: "" });
    setbranch({ branchId: "" });
    setsuppliersdata(suppliersdata.slice());
    setvatsData(activevatsdata.slice());
    setfeeearnerData(feeearnerdata.slice());
    setresetDocs(!resetDocs);
    setcounselfee(false);
    dispatch(clearFile("Chit Request"));
  };

  const { isSuccess, uploadForm, progress } = useUploadForm();

  const [filesData, setFilesData] = useState([]);

  const handleUpload = async (e) => {
    let data = onFileUpload(e);
    setFilesData([...filesData, data]);
    const parameters = {
      documentType: "Posting",
      matterId: matter?.matterId || "",
      supplierRef: suppliervalue?.supplierRef || "",
      nominalRef: nominal?.nominalRef || "",
    };
    const dataChoosen = await uploadForm(data, e.target.files[0], parameters);
    data.fileID = dataChoosen.data.data.fileID;
    dispatch(addFiles("Chit Request", dataChoosen));
  };
  const onFileRemove = (fileId) => {
    setFilesData((prev) => prev.filter((file) => file.fileID !== fileId));
  };

  const comboBoxesInfo = [
    {
      key: "OfficeBank",
      label: "Office Bank",
      condition: false,
      data: officedata,
      onFilterChange: filterChangeofficebank,
      value: officevalue,
      onChange: onChangeofficebank,
      placeholder: "Search Office Bank",
    },
    {
      key: "SupplierRef",
      label: "Supplier Ref",
      condition: suppliervalue.supplierRef === "",
      data: suppliersdata,
      onFilterChange: filterChangesupplier,
      value: suppliervalue,
      onChange: onChangesupplier,
      field: "display",
      placeholder: "Search Supplier Ref",
    },
    {
      key: "ClientBank",
      label: "Client Bank",
      condition: false,
      data: clientdata,
      onFilterChange: filterChangeclientbank,
      value: clientvalue,
      onChange: onChangeclientbank,
      placeholder: "Search Client Bank",
    },
    {
      key: "DDABank",
      label: "DDA Bank",
      condition: false,
      data: ddadata,
      onFilterChange: filterChangeddabank,
      value: ddavalue,
      onChange: onChangeddabank,
      placeholder: "Search DDA Bank",
    },
    {
      key: "NominalRef",
      label: "Nominal Ref",
      condition: nominal.nominalRef === "",
      data: nominaldata,
      onFilterChange: filternominal,
      value: nominal,
      onChange: onChangenominal,
      placeholder: "Search Nominal Ref",
    },
  ];

  const ChitRequestContent = () => {
    return (
      <div
        className={`${!IS_MODAL ? "vh-100" : "mx-4 h-100"} ${
          styles["main-container"]
        }`}
        style={{ position: 'relative' }}
      >
        {isLoadingChitData && (
          <div 
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 1000
            }}
          >
            <div className="text-center">
              <div className="spinner-border text-primary mb-2" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <div>Loading Chit Request data...</div>
            </div>
          </div>
        )}
        <div className="bgForm overflow-auto">
          <div
            className="px-lg-5 px-3 "
            style={{
              maxHeight: !IS_MODAL ? "calc(100vh - 130px)" : "auto",
              maxWidth: "950px",
              overflow: "auto",
            }}
          >
            <form onSubmit={handlesubmit}>
              <div className="d-flex align-items-end mt-3 ">
                <div className="d-flex flex-column  me-5">
                  <div className="d-flex flex-column mb-2">
                    <Label className="label mb-1">Posting Type</Label>
                    <DropDownList
                      className={`${styles["input-styles"]}`}
                      style={{
                        border:
                          validation_message && !type
                            ? "1px solid red"
                            : undefined,
                      }}
                      data={postingTypes}
                      textField={"display"}
                      iconClassName="wa"
                      dataItemKey="code"
                      value={type}
                      onChange={handleChange}
                      placeholder="Select Type"
                    />
                  </div>
                  <div className="d-flex flex-column">
                    <Label className="label mb-1">Matter</Label>
                    <MattersCombobox
                      className={`${styles["input-styles"]}`}
                      onChangematter={onChangematter}
                      disabled={IS_MODAL}
                      error={validation_message && !matterref}
                      value={
                        IS_MODAL ? props.matter : matterref ? matter : null
                      }
                    />
                  </div>
                  <div className="d-flex flex-column mt-2">
                    <Label className="label mb-1">Date</Label>
                    <DatePicker
                      className={`${styles["input-styles"]} px-2`}
                      value={dateselector}
                      width={280}
                      onChange={onChangedateselect}
                      toggleButton={CalenderCustomToggleButton}
                    />
                  </div>
                </div>

                <div className="pe-1">
                  <div>
                    <MatterDetails matter={matter} clear={matterBalanceClear} />
                  </div>
                  <div className="mt-2 mb-2">
                    <MatterAccount
                      component={"Chit Request"}
                      clear={matterBalanceClear}
                      matterId={matter?.matterId}
                      width={"480px"}
                    />
                  </div>
                </div>
              </div>
              <div className="d-flex">
                {list.includes("Reference") && (
                  <div className="d-flex flex-column mt-2 me-5">
                    <Label className="label mb-1">Reference</Label>
                    <Input
                      className={`${styles["input-styles"]}`}
                      value={state}
                      onChange={(e) => {
                        setstate(e.target.value);
                      }}
                      placeholder={"Add Reference"}
                    />
                  </div>
                )}
                <div className="d-flex flex-column">
                  {comboBoxesInfo.map(
                    ({
                      key,
                      label,
                      condition,
                      data,
                      onFilterChange,
                      value,
                      onChange,
                      field,
                      placeholder,
                    }) =>
                      list?.includes(key) ? (
                        <ComboBoxComponent
                          key={key}
                          label={label}
                          className={`${styles["input-styles"]}`}
                          style={{
                            border:
                              validation_message && condition
                                ? "1px solid red"
                                : "",
                          }}
                          data={data}
                          textField={field || "representation"}
                          filterable={true}
                          onFilterChange={onFilterChange}
                          value={value}
                          onChange={onChange}
                          placeholder={placeholder}
                        />
                      ) : null
                  )}
                </div>
              </div>
              <div className="d-flex mt-2">
                {list.includes("NetAmount") && (
                  <div className="d-flex flex-column me-5">
                    <Label className="label mb-1">Net amount</Label>
                    <NumericTextBox
                      value={netamount}
                      className={`${styles["input-styles"]}`}
                      style={{
                        border:
                          validation_message &&
                          (netamount === 0 || netamount === "") &&
                          "1px solid red",
                      }}
                      inputStyle={{ textAlign: "right" }}
                      onChange={(e) => {
                        setnetamount(e.target.value);
                        if (vatvalue !== undefined) {
                          calculatevatamount();
                        }
                      }}
                      spinners={false}
                      format="n2"
                      placeholder="0.00"
                    />
                  </div>
                )}
                <div className="d-flex">
                  {list.includes("VatCode") && (
                    <div className="d-flex flex-column me-3">
                      <Label className="label mb-1">VAT</Label>
                      <ComboBox
                        className={`${styles["small-inputbox"]}`}
                        style={{
                          border:
                            validation_message && 
                            (type.code !== "ODR" &&
                             type.code !== "OCR" &&
                             type.code !== "CDR" &&
                             type.code !== "CCR" &&
                             type.code !== "DDR" &&
                             type.code !== "DCR") &&
                            vatvalue === undefined
                              ? "1px solid red"
                              : undefined,
                        }}
                        data={activevatsdata}
                        textField={"display"}
                        filterable={true}
                        onFilterChange={filterChange}
                        value={vatvalue}
                        onChange={onChangevat}
                        placeholder={"Code"}
                      />
                    </div>
                  )}
                  {list.includes("VatAmount") && (
                    <div className="d-flex flex-column">
                      <Label className="label mb-1">VAT Amount</Label>
                      <NumericTextBox
                        className={`${styles["small-inputbox"]}`}
                        value={vatamount}
                        readOnly={true}
                        placeholder="0.00"
                        spinners={false}
                        format="n2"
                        inputStyle={{ textAlign: "right" }}
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className="d-flex between mt-2">
                {list.includes("FeeEarnerRef") && (
                  <div className="d-flex flex-column me-5">
                    <Label className="label mb-1">Fee Earner</Label>
                    <ComboBox
                      className={`${styles["input-styles"]}`}
                      style={{
                        border:
                          validation_message && !feeearnerref
                            ? "1px solid red"
                            : undefined,
                      }}
                      data={feeearner}
                      iconClassName="wa"
                      textField={`display`}
                      filterable
                      onFilterChange={filterfeeearner}
                      placeholder={"Search Fee Earner"}
                      value={feeearnerref}
                      onChange={onChangefeeearner}
                    />
                  </div>
                )}
                <div className="d-flex flex-column">
                  {list.includes("Payer") && (
                    <div className="d-flex flex-column">
                      <Label className="label mb-1">Payer</Label>
                      <div className="validator">
                        <Input
                          value={payer}
                          className={`${styles["input-styles"]}`}
                          style={{
                            border:
                              validation_message && !payer
                                ? "1px solid red"
                                : "",
                          }}
                          onChange={(e) => {
                            setpayer(e.target.value);
                          }}
                          placeholder={"Add Payer"}
                        ></Input>
                      </div>
                    </div>
                  )}
                </div>
                <div className="d-flex flex-column">
                  {list.includes("Payee") && (
                    <div className="d-flex flex-column">
                      <Label className="label mb-1">Payee</Label>
                      <div className="validator">
                        <Input
                          className={`${styles["input-styles"]}`}
                          style={{
                            border:
                              validation_message && !payee
                                ? "1px solid red"
                                : "",
                          }}
                          value={payee}
                          onChange={(e) => {
                            setpayee(e.target.value);
                          }}
                          placeholder={"Add Payee"}
                        ></Input>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="d-flex flex-column mt-2">
                <Label className="label mb-1">Details</Label>
                <TextArea
                  value={details}
                  className={`${styles["details-textbox"]}`}
                  style={{
                    border:
                      validation_message === true && !details
                        ? "1px solid red"
                        : "",
                  }}
                  rows={5}
                  multiple={true}
                  placeholder="Enter Details"
                  onChange={(e) => {
                    setdetails(e.target.value);
                  }}
                />
              </div>

              <div className="mt-1 d-flex justify-content-start me-5">
                <DocumentsUpload
                  open={documentUpload}
                  value={type}
                  type={"Chit Request"}
                  resetDocs={resetDocs}
                  progress={progress}
                  filesData={filesData}
                  onFileRemove={onFileRemove}
                  onError={() => {
                    const newFiles = filesData.splice(filesData.length, 1);
                    setFilesData([...newFiles]);
                  }}
                  onUpload={handleUpload}
                />
              </div>

              {!IS_MODAL && (
                <div className={`my-2 d-flex justify-content-end`}>
                  <Button
                    className="common-btn bgBtnSecondary me-3"
                    type="button"
                    onClick={() => {
                      resetfields();
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    id="chit-request-post"
                    className="common-btn" 
                    isLoading={loading}
                    disabled={loading}
                    type="submit"
                  >
                     {props.activityData?.chitRequestId ? "Update" : "Post"}
                  </Button>
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    );
  };

  const renderContent = () => {
    return ChitRequestContent();
  };

  return IS_MODAL ? (
    <Dialog
      title={props.activityData?.chitRequestId ? "Edit Chit Request" : "Chit Request"}
      onClose={props.cancelEdit}
      className="dialog-xmd"
    >
      {renderContent()}
      <DialogActionsBar>
        <div className={`float-end w-100 dialog-footer`}>
          <Button
            className="common-btn bgBtnSecondary me-3"
            type="button"
            onClick={() => {
              resetfields();
              if (IS_MODAL) props.cancelEdit();
            }}
          >
            Cancel
          </Button>
          <SubmitButton
            className="me-3"
            id="chit-request-post"
            type="submit"
            onClick={handlesubmit}
          >
                 {props.activityData?.chitRequestId ? "Update" : "Post"}
          </SubmitButton>
        </div>
      </DialogActionsBar>
    </Dialog>
  ) : (
    renderContent()
  );
};
export default ChitRequest;
